<template>
  <div class="header">
    <!-- <div class="d-flex justify-content-center ">
      <img src="https://api-lunacy.icons8.com/api/assets/5556954d-29aa-47be-b049-c25e41ec7fe7/Information Pyramid icon.png" alt="">
  </div> -->

    <nav class="navbar navbar-expand-md navbar-light bg-light">
      <!-- Brand -->
      <a class="navbar-brand" href="#">
        <!-- <img src="../assets/logo.png" width="30" height="30" alt /> -->
        <router-link to="/profile">
          Hi,{{
          getUname()
        }}
        </router-link>
        <!-- <span class="badge badge-dark">{{ msg }}</span> -->
        <!-- <span class="lag">&#128011;</span> -->
      </a>
      <!-- Toggler/collapsibe Button -->
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#collapsibleNavbar"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <!-- Navbar links -->
      <div class="collapse navbar-collapse " id="collapsibleNavbar">
        <ul class="navbar-nav" v-if="msg == 'admin'">
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="donActive()">Tạo đơn mới <b>&#9994;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'AdminNewOrder' }"
              >Tạo đơn mới <b>&#9994;</b></router-link
            >
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="quanLyDonActive()">Quản lý đơn <b>&#128075;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'AdminOrder' }"
              >Quản lý đơn <b>&#128075;</b></router-link
            >
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="quanLyNVActive()">Quản lý nhân viên <b>&#128079;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'AdminMember' }"
              >Quản lý nhân viên <b>&#128079;</b></router-link
            >
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="quanLyCTVActive()">Quản lý cộng tác viên <b>&#128076;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'AdminEditor' }"
              >Quản lý cộng tác viên <b>&#128076;</b></router-link
            >
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="setAction(5)">Báo cáo thống kê <b>&#127881;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'AdminReport' }"
              >Báo cáo thống kê<b>&#128076;</b></router-link
            >
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link" @click="logout()"
              >Đăng xuất <b>&#128074;</b></a
            >
          </li>
        </ul>
        <ul class="navbar-nav" v-if="msg == 'editor'">
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="donActive()">Tạo đơn mới <b>&#9994;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'EditorNewOrder' }"
              >Tạo đơn mới <b>&#9994;</b></router-link
            >
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="quanLyDonActive()">Quản lý đơn <b>&#128075;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'EditorOrder' }"
              >Quản lý đơn <b>&#128075;</b></router-link
            >
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="quanLyNVActive()">Quản lý nhân viên <b>&#128079;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'EditorMember' }"
              >Quản lý nhân viên <b>&#128079;</b></router-link
            >
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="setAction(5)">Báo cáo thống kê <b>&#127881;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'EditorReport' }"
              >Báo cáo thống kê<b>&#128076;</b></router-link
            >
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link" @click="logout()"
              >Đăng xuất <b>&#128074;</b></a
            >
          </li>
        </ul>
        <ul class="navbar-nav" v-else-if="msg == 'member'">
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="donActive()">Tạo đơn mới <b>&#9994;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'MemberNewOrder' }"
              >Tạo đơn mới <b>&#9994;</b></router-link
            >
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="quanLyDonActive()">Quản lý đơn <b>&#128075;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'MemberOrder' }"
              >Quản lý đơn <b>&#128075;</b></router-link
            >
          </li>
          <li class="nav-item">
            <!-- <a class="nav-link" href="#" @click="setAction(5)">Báo cáo thống kê <b>&#127881;</b></a> -->
            <router-link class="nav-link" :to="{ name: 'MemberReport' }"
              >Báo cáo thống kê<b>&#128076;</b></router-link
            >
          </li>
          <li class="nav-item">
            <a href="#" class="nav-link" @click="logout()"
              >Đăng xuất <b>&#128074;</b></a
            >
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    msg: String
  },
  data() {
    return {
      whoami: sessionStorage.getItem("id"),
      action: ""
    };
  },
  methods: {
    getUname() {
      return sessionStorage.getItem("name");
    },

    logout() {
      sessionStorage.removeItem("id");
      sessionStorage.removeItem("username");
      sessionStorage.removeItem("password");
      sessionStorage.removeItem("name");
      sessionStorage.removeItem("role");
      sessionStorage.removeItem("gender");
      sessionStorage.removeItem("address");
      sessionStorage.removeItem("phone");
      sessionStorage.removeItem("facebook");
      sessionStorage.removeItem("created");
      sessionStorage.removeItem("owned");
      sessionStorage.removeItem("active");
      this.$router.push("/");
    }
  },

  beforeCreate() {
    if (sessionStorage.getItem("role") == null) {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped lang="css">
* {
  font-family: "Fira Sans";
}
a {
  text-decoration: none !important;
}
button {
  border: none !important;
  font-size: 1em !important;
  outline: none;
  margin-top: 0 !important;
  box-shadow: none !important;
}
.navbar {
  background: #5bffd1;
}
.navbar a {
  color: #2c3e50 !important;
}
@import url("https://fonts.googleapis.com/css2?family=Pacifico&display=swap");
.navbar-brand {
  font-family: "Pacifico" !important;
}
@media screen and (max-width: 1000px) {
  .nav-link:hover,
  .nav-link:active {
    background-color: #34495e;
    transition: 0.4s;
    padding-left: 1.5rem;
    border-radius: 4px;
    color: white !important;
  }
}
@media screen and (min-width: 480px) {
  .nav-link:hover,
  .nav-link:active {
    background-color: #34495e;
    transition: 0.4s;
    border-radius: 4px;
    color: white !important;
  }
}
#collapsibleNavbar {
  padding-left: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue